export function initTriBackground() {

	const svg = document.getElementById("js-triSvg");
	if (!svg) return;

	const NS = "http://www.w3.org/2000/svg";

	const SIZE = 80; // 三角サイズ
	const SAT = 50; // 彩度
	const SPEED = 0.015; // 動きの速さ
	const ALPHA = 0.8; // 透明度

	let tris = [];
	let t = 0;
	let W, H;

	function build() {

		W = window.innerWidth;
		H = window.innerHeight;

		svg.innerHTML = "";
		svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
		tris = [];

		const cols = Math.ceil(W / SIZE) + 1;
		const rows = Math.ceil(H / SIZE) + 1;

		for (let r = 0; r < rows; r++) {
			for (let c = 0; c < cols; c++) {

				const x = c * SIZE;
				const y = r * SIZE;

				const cx = x + SIZE / 2;
				const cy = y + SIZE / 2;

				const pTL = { x: x, y: y };
				const pTR = { x: x + SIZE, y: y };
				const pBR = { x: x + SIZE, y: y + SIZE };
				const pBL = { x: x, y: y + SIZE };
				const pC = { x: cx, y: cy };

				// マスごとにランダム回転
				const rotation = Math.floor(Math.random() * 4);

				const patterns = [
					[
						[pTL, pTR, pC],
						[pTR, pBR, pC],
						[pBR, pBL, pC],
						[pBL, pTL, pC]
					],
					[
						[pTR, pBR, pC],
						[pBR, pBL, pC],
						[pBL, pTL, pC],
						[pTL, pTR, pC]
					],
					[
						[pBR, pBL, pC],
						[pBL, pTL, pC],
						[pTL, pTR, pC],
						[pTR, pBR, pC]
					],
					[
						[pBL, pTL, pC],
						[pTL, pTR, pC],
						[pTR, pBR, pC],
						[pBR, pBL, pC]
					],
				];

				patterns[rotation].forEach((tri, i) => {
					addTri(tri, i);
				});

			}
		}
	}

	function addTri(points, index) {

		const poly = document.createElementNS(NS, "polygon");
		poly.setAttribute("points",
			points.map(p => `${p.x},${p.y}`).join(" ")
		);

		const cx = (points[0].x + points[1].x + points[2].x) / 3;
		const cy = (points[0].y + points[1].y + points[2].y) / 3;

		poly.dataset.cx = cx;
		poly.dataset.cy = cy;

		// マス単位の乱数
		poly.dataset.seed = Math.random() * 1000;

		svg.appendChild(poly);
		tris.push(poly);
	}

	function animate() {
		t += SPEED;

		tris.forEach(tri => {
			const x = parseFloat(tri.dataset.cx);
			const y = parseFloat(tri.dataset.cy);
			const seed = parseFloat(tri.dataset.seed);

			const nx = x / W;
			const ny = y / H;
			const diag = (nx + (1 - ny)) / 2;

			let hue = 80 + 240 * diag + t * 40;

			// ゆるい揺れ
			hue += 20 * Math.sin(t + seed);

			// ベースの明るさ
			const baseLight = 68 + 12 * Math.sin(seed + t * 0.8);

			// ===== 斜め45°方向の白抜け =====

			const cx0 = 0.5;
			const cy0 = 0.5;

			const dx = nx - cx0;
			const dy = ny - cy0;

			// ゆっくり回転する角度
			const angle = t * 0.4; // 数値小さいほどゆっくり

			// 座標を回転
			const rx = dx * Math.cos(angle) - dy * Math.sin(angle);
			const ry = dx * Math.sin(angle) + dy * Math.cos(angle);

			// 回転後の斜め距離
			const diagonal = (rx - ry);

			// 絶対値で帯にする
			const dist = Math.abs(diagonal);

			// 範囲（大きくするなら 0.8 → 1.0）
			const radius = 1.2;

			let centerBoost = 1 - (dist / radius);
			centerBoost = Math.max(0, centerBoost);

			// フラット気味に
			centerBoost = Math.pow(centerBoost, 1); // 端の落ち方をなだらかに（白の強さを抑える）


			let finalLight = baseLight + centerBoost * 50;
			finalLight = Math.min(finalLight, 98); // 92%あたりが自然
			
			tri.setAttribute("fill",
				`hsla(${hue}, ${SAT}%, ${finalLight}%, ${ALPHA})`
			);
		});

		requestAnimationFrame(animate);
	}

	build();
	animate();
	window.addEventListener("resize", build);

}